import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";

interface StateInterface {
  isFetching: boolean;
  error: boolean;
  message: string;
  email: string;
  company: {
    name: string,
  };
  contact: {
    firstName: string,
    lastName: string,
  };
  fields: string[];
};

const initialState: StateInterface = {
  isFetching: false,
  error: true,
  message: '',
  email: '',
  company: {
    name: '',
  },
  contact: {
    firstName: '',
    lastName: '',
  },
  fields: []
};

export const signupReducer = (state: StateInterface = initialState, action: ActionInterface): StateInterface => {
  switch (action.type) {
    case Constants.PAGE_SIGNUP_UPDATE_EMAIL:
      return { ...state,
        email: action.payload?.email
      };

    case Constants.PAGE_SIGNUP_UPDATE_COMPANY:
      return {...state,
        company: {
          name: action.payload?.name
        }
      };

    case Constants.PAGE_SIGNUP_UPDATE_CONTACT:
      return {
        ...state,
        contact: {
          ...state.contact,
          ...action.payload
        }
      };

    case Constants.PAGE_SIGNUP_REQUEST:
      return { ...state,
        isFetching: true,
        error: false
      };

    case Constants.PAGE_SIGNUP_SUCCESS:
      return { ...state,
        isFetching: false,
      };

    case Constants.PAGE_SIGNUP_FAILURE:
      return { ...state,
        isFetching: false,
        message: action.payload?.message,
        fields: action.payload?.fields || [],
        error: true
      };

    case Constants.PAGE_SIGNUP_CLEAR:
      return {
        ...initialState
      };

    case Constants.AUTH_SIGNOUT:
      return {
        ...initialState
      };

    default:
      return state;
  }
};
